import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=5e0f2bae"
import script from "./NoResults.vue?vue&type=script&lang=ts"
export * from "./NoResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports